<template>
  <div v-if="shouldShow" class="bg-gray-1">
    <div class="container container-s padding-2xl-vertical">
      <h2 class="margin-xl-bottom text-center">{{ t("justopp.signUpSection.title") }}</h2>
      <div class="button-container flex-middle flex-center">
        <saffron-link
          v-slot="{ navigate }"
          class="plain-link"
          :to="{ name: 'user-register' }">
          <form-button class="register-button" theme="inverse-lead" @click="navigate">{{
            t("justopp.signUpSection.ctaText")
          }}</form-button>
        </saffron-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  computed: {
    shouldShow() {
      const isRegistering =
        this?.$route?.name === "user-register" ||
        this?.$route?.name === "vendor-register";
      return !this.$store.getters["user/isAuthenticated"] && !isRegistering;
    },
  },
};
</script>

<style scoped lang="scss">
.justopp-footer {
  min-height: 200px;
  border-top: 5px solid var(--c-lead);
}

.footer-nav {
  ul {
    padding-inline-start: 0;
    list-style: none;

    li {
      margin-bottom: var(--margin-s);
    }
  }
}

.register-button {
  width: 200px;

  :deep(.button-text) {
    line-height: var(--font-2xl) !important;
    font-weight: 500;
  }
}
</style>
